import type { AiAnalysis } from "../../../services/sheai/SheAiChecklistTypes";

type Transcript = NonNullable<AiAnalysis["transcript"]>;

const secondsFrom = (value: number | string | undefined): number | null => {
  if (typeof value === "number") return Number.isFinite(value) ? value : null;
  if (typeof value !== "string") return null;

  const trimmed = value.trim();
  if (/^\d+(?:\.\d+)?$/.test(trimmed)) return Number(trimmed);
  if (!/^\d+:\d{2}(?::\d{2})?(?:\.\d+)?$/.test(trimmed)) return null;

  const parts = trimmed.split(":").map(Number);
  return parts.reduce((seconds, part) => seconds * 60 + part, 0);
};

const vttTime = (seconds: number): string => {
  const milliseconds = Math.round(seconds * 1000);
  const hours = Math.floor(milliseconds / 3600000);
  const minutes = Math.floor((milliseconds % 3600000) / 60000);
  const secs = Math.floor((milliseconds % 60000) / 1000);
  const millis = milliseconds % 1000;
  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}.${String(millis).padStart(3, "0")}`;
};

/** Converte os trechos já produzidos pela análise ADK em legendas nativas do vídeo. */
export function transcriptToVtt(transcript: Transcript | undefined): string | null {
  const cues = (transcript || []).flatMap((segment) => {
    const start = secondsFrom(segment.start ?? segment.ts_start);
    const end = secondsFrom(segment.end ?? segment.ts_end);
    const text = String(segment.text || segment.transcription || "")
      .replace(/\s+/g, " ")
      .trim()
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/-->/g, "→");

    if (start === null || end === null || start < 0 || end <= start || !text) return [];
    return [{ start, end, text }];
  });

  if (cues.length === 0) return null;

  return `WEBVTT\n\n${cues
    .sort((a, b) => a.start - b.start)
    .map((cue, index) => `${index + 1}\n${vttTime(cue.start)} --> ${vttTime(cue.end)}\n${cue.text}`)
    .join("\n\n")}\n`;
}
